import { LocationDTO } from '../../dto/location/location.dto';
import { Room } from './Room.model';

export class Location {
    public data?: {
        firefighter_count?: number;
        ok_percentage?: number;
        registered_percentage?: number;
        progress_percentage?: number;
        [key: string]: any;
    };
    public rooms?: Room[];
    
    // Flattened properties for table display
    public firefighter_count: number = 0;
    public ok_percentage: number = 0;
    public registered_percentage: number = 0;
    public progress_percentage: number = 0;
    
    public id?: number;
    public profile_image_obfuscated_name?: string | null;

    constructor(
        public guid: string,
        public locations_name: string,
        public clean_name: string
    ) {}

    static fromDTO(dto: LocationDTO): Location {
        const location = new Location(
            dto.guid,
            dto.locations_name,
            dto.clean_name
        );
        
        location.data = dto.data;
        location.rooms = dto.rooms;
        
        // Set flattened properties from top-level properties
        location.firefighter_count = dto.firefighter_count || 0;
        location.registered_percentage = dto.registered_percentage || 0;
        location.progress_percentage = dto.progress_percentage || 0;
        location.ok_percentage = dto.ok_percentage || 0;
        location.id = dto.id;
        location.profile_image_obfuscated_name = dto.profile_image_obfuscated_name ?? null;
        
        return location;
    }
} 